/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import Arrow from '../icons/Arrow';
import RoundedButton from './Rounded';

import styles from '../../../styles/buttons/cta-button.module.scss';

const propTypes = {
    href: PropTypes.string,
    disabled: PropTypes.bool,
    withArrow: PropTypes.bool,
    isLarge: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
    children: AppPropTypes.label,
};

const defaultProps = {
    href: null,
    disabled: false,
    withArrow: true,
    isLarge: true,
    className: null,
    onClick: null,
    children: null,
};

const CtaButton = ({
    href,
    disabled,
    withArrow,
    isLarge,
    className,
    onClick,
    children,
    ...props
}) => (
    <RoundedButton
        href={href}
        onClick={onClick}
        className={classNames([styles.container, { [className]: className !== null }])}
        icon={withArrow ? <Arrow /> : null}
        iconPosition="left"
        disabled={disabled}
        isLarge={isLarge}
        {...props}
    >
        {children}
    </RoundedButton>
);

CtaButton.propTypes = propTypes;
CtaButton.defaultProps = defaultProps;

export default CtaButton;
